import { styled } from '@mui/material';
import { colors } from 'components/Colors';

const SimpleLoaderWrapper = styled('div')`
  .MuiBox-root {
    position: relative;
    & > :first-of-type {
      color: ${colors.green.lightTeal.value};
    }
    & > :last-child {
      position: absolute;
      left: 0;
    }
  }
`;

export default SimpleLoaderWrapper;
